<template>
  <PaymeComponent></PaymeComponent>
</template>

<script>
import PaymeComponent from '@/components/Redirect/PaymeRedirect'

export default {
  name: 'RedirectView',
  components: {
    PaymeComponent
  }
}
</script>